// src/pages/Auth/RegisterWithMap.js
import React from "react";
import { LoadScript } from "@react-google-maps/api";
import Register from "./Register";

const RegisterWithMap = () => {
const GOOGLE_MAPS_API_KEY = "AIzaSyDxpKBuxXpQRXU3XL97I4qqf2dbE_5M7Z0";

  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={["places"]} // if you're using Places Autocomplete
    >
      <Register apiKey={GOOGLE_MAPS_API_KEY} />
    </LoadScript>
  );
};

export default RegisterWithMap;
